/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: #acacac;
  }
`

export default class PickOffIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="146" height="146" viewBox="0 0 146 146" css={Color}>
          <g id="그룹_3750" data-name="그룹 3750" transform="translate(-453 -969)">
            <g id="패스_3653" data-name="패스 3653" transform="translate(462 978)" fill="#acacac">
              <path
                d="M 64 132.5 C 54.75453948974609 132.5 45.78326034545898 130.6882629394531 37.33531951904297 127.1150817871094 C 33.27545928955078 125.3979034423828 29.36004066467285 123.2727432250977 25.69786071777344 120.7985992431641 C 22.07164001464844 118.3487777709961 18.66184043884277 115.5354614257813 15.5631799697876 112.4368209838867 C 12.46453952789307 109.3381576538086 9.651220321655273 105.9283599853516 7.201399803161621 102.3021392822266 C 4.727260112762451 98.63996124267578 2.602099895477295 94.72454071044922 0.8849200010299683 90.66468048095703 C -2.688260078430176 82.21674346923828 -4.5 73.24546051025391 -4.5 64 C -4.5 54.75453948974609 -2.688260078430176 45.78326034545898 0.8849200010299683 37.33531951904297 C 2.602099895477295 33.27545928955078 4.727260112762451 29.36004066467285 7.201399803161621 25.69786071777344 C 9.651220321655273 22.07164001464844 12.46453952789307 18.66184043884277 15.5631799697876 15.5631799697876 C 18.66184043884277 12.46453952789307 22.07164001464844 9.651220321655273 25.69786071777344 7.201399803161621 C 29.36004066467285 4.727260112762451 33.27545928955078 2.602099895477295 37.33531951904297 0.8849200010299683 C 45.78326034545898 -2.688260078430176 54.75453948974609 -4.5 64 -4.5 C 73.24546051025391 -4.5 82.21674346923828 -2.688260078430176 90.66468048095703 0.8849200010299683 C 94.72454071044922 2.602099895477295 98.63996124267578 4.727260112762451 102.3021392822266 7.201399803161621 C 105.9283599853516 9.651220321655273 109.3381576538086 12.46453952789307 112.4368209838867 15.5631799697876 C 115.5354614257813 18.66184043884277 118.3487777709961 22.07164001464844 120.7985992431641 25.69786071777344 C 123.2727432250977 29.36004066467285 125.3979034423828 33.27545928955078 127.1150817871094 37.33531951904297 C 130.6882629394531 45.78326034545898 132.5 54.75453948974609 132.5 64 C 132.5 73.24546051025391 130.6882629394531 82.21674346923828 127.1150817871094 90.66468048095703 C 125.3979034423828 94.72454071044922 123.2727432250977 98.63996124267578 120.7985992431641 102.3021392822266 C 118.3487777709961 105.9283599853516 115.5354614257813 109.3381576538086 112.4368209838867 112.4368209838867 C 109.3381576538086 115.5354614257813 105.9283599853516 118.3487777709961 102.3021392822266 120.7985992431641 C 98.63996124267578 123.2727432250977 94.72454071044922 125.3979034423828 90.66468048095703 127.1150817871094 C 82.21674346923828 130.6882629394531 73.24546051025391 132.5 64 132.5 Z"
                stroke="none"
              />
              <path
                d="M 64 0 C 28.65377807617188 0 0 28.65377807617188 0 64 C 0 99.34622192382813 28.65377807617188 128 64 128 C 99.34622192382813 128 128 99.34622192382813 128 64 C 128 28.65377807617188 99.34622192382813 0 64 0 M 64 -9 C 104.252326965332 -9 137 23.74767303466797 137 64 C 137 104.252326965332 104.252326965332 137 64 137 C 23.74767303466797 137 -9 104.252326965332 -9 64 C -9 23.74767303466797 23.74767303466797 -9 64 -9 Z"
                stroke="none"
                fill="#acacac"
              />
            </g>
            <text
              id="PICK"
              transform="translate(484 1036)"
              fill="#fff"
              fontSize="38"
              fontFamily="NotoSansCJKkr-Regular, Noto Sans CJK KR"
            >
              <tspan x="0" y="0">
                PICK
              </tspan>
            </text>
            <text
              id="OFF"
              transform="translate(481 1082)"
              fill="#fff"
              fontSize="48"
              fontFamily="NotoSansCJKkr-Regular, Noto Sans CJK KR"
            >
              <tspan x="0" y="0">
                OFF
              </tspan>
            </text>
          </g>
        </svg>
      </Fragment>
    )
  }
}
